import React, { useEffect } from "react";
import "./DataScience.css";
import appImg from "../../assets/images/Data-Science.png";

const DataScience = () => {
  useEffect(() => {
    const sections = document.querySelectorAll(".reveal-app");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-app");
          }
        });
      },
      { threshold: 0.2 }
    );

    sections.forEach((sec) => observer.observe(sec));
  }, []);

  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="app-hero-section reveal-app">
        <div className="app-hero-container">
          {/* LEFT TEXT */}
          <div className="app-hero-text reveal-app">
            <h1>Data Science</h1>

            <p>
            In today’s digital age, data isn’t just numbers—it’s knowledge, insight, and opportunity. That’s why we’re thrilled to introduce Data Science Services at NMD Info Tech Services.
            </p>

            <p>
            Whether you’re looking to understand your customers better, predict market trends, or make smarter business decisions, we’re here to turn your data into actionable intelligence. With advanced analytics, machine learning, and a human-first approach, we help you not just keep up with the future—but stay ahead of it.

Let’s transform data into decisions, and insights into impact—together.</p>


           

            <button className="app-hero-btn">Get Started</button>
          </div>

          {/* RIGHT IMAGE */}
          <div className="app-hero-image reveal-app">
            <img src={appImg} alt="App Development" />
          </div>
        </div>
      </section>

      {/* ================= SECOND FORM SECTION ============================================== */}
      <section className="app-second-section reveal-app">
  <div className="app-second-container">

    {/* LEFT FORM BOX */}
    <div className="app-form-box reveal-app">
      <h2>Get an Appointment</h2>

      <form
        action="https://api.web3forms.com/submit"
        method="POST"
      >
        {/* REQUIRED: WEB3FORMS ACCESS KEY */}
        <input
          type="hidden"
          name="access_key"
          value="157f5dfc-898c-4749-aab8-a80e612db795"
        />

        <input type="text" name="name" placeholder="Name *" required />
        <input type="email" name="email" placeholder="Email *" required />
        <textarea name="message" placeholder="Message Here" rows="5"></textarea>

        <button type="submit" className="app-send-btn">Send</button>
      </form>
    </div>

    {/* RIGHT TEXT CONTENT */}
    <div className="app-second-text reveal-app">
      <h1>Why Data Science?</h1>

      <p>
        In a world where data is abundant, the ability to extract meaningful insights has become essential for businesses aiming to stay ahead. Data Science is the key to transforming vast amounts of raw data into valuable, actionable information that drives smarter decisions, enhances customer experiences, and fuels innovation.
      </p>

      <p>
        At NMD Info Tech Services, we understand the immense potential of Data Science and how it can reshape your business strategies. Our goal is to help you navigate the complexities of data to uncover trends, predict future outcomes, and optimize processes. By leveraging advanced analytics and machine learning, we provide customized solutions that cater to your specific needs and goals.

        Let us help you unlock the true power of your data, and turn insights into impact. Let’s build it.
      </p>

      <p>
        As smartphones become our go-to for everything, businesses that
        embrace app development aren’t just keeping up — they’re <strong>leading the way.</strong>
      </p>
    </div>
  </div>
</section>

      
         {/* third section */}
     
      <section className="app-features-section reveal-app">
  <h2 className="app-feature-title">More Solutions We Offer</h2>
  
  <div className="scroll-line"></div>


  <div className="app-features-container">

   {/* CARD 1 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">📡</div>
      <h3>Custom App Development</h3>
      <p>Tailored to meet the specific needs of our clients, we develop native and cross-platform applications for iOS and Android platforms.</p>
    </div>

    <div className="card-back">
      <h3>Custom App Development</h3>
      <p>Tailored to meet the specific needs of our clients, we develop native and cross-platform applications for iOS and Android platforms.</p>
    </div>
  </div>
</div>


{/* CARD 2 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">🛠️</div>
      <h3>UI/UX Design</h3>
      <p>Our team of experienced designers ensures a visually appealing and user-friendly interface, enhancing the overall user experience.</p>
    </div>

    <div className="card-back">
      <h3>UI/UX Design</h3>
      <p>Our team of experienced designers ensures a visually appealing and user-friendly interface, enhancing the overall user experience.</p>
    </div>
  </div>
</div>


{/* CARD 3 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">⚡</div>
      <h3>Backend Development</h3>
      <p>We build robust and scalable backend systems, ensuring seamless integration of features and optimal performance.</p>
    </div>

    <div className="card-back">
      <h3>Backend Development</h3>
      <p>We build robust and scalable backend systems, ensuring seamless integration of features and optimal performance.</p>
    </div>
  </div>
</div>


{/* CARD 4 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">🔐</div>
      <h3>Quality Assurance</h3>
      <p>Rigorous testing procedures ensure flawless performance and excellent user experience.</p>
    </div>

    <div className="card-back">
      <h3>Quality Assurance</h3>
      <p>Rigorous testing procedures ensure flawless performance and excellent user experience.</p>
    </div>
  </div>
</div>


{/* CARD 5 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">☁️</div>
      <h3>Maintenance & Support</h3>
      <p>We offer ongoing support and maintenance to keep applications updated, secure, and aligned with evolving standards.</p>
    </div>

    <div className="card-back">
      <h3>Maintenance & Support</h3>
      <p>We offer ongoing support and maintenance to keep applications updated, secure, and aligned with evolving standards.</p>
    </div>
  </div>
</div>

  </div>
</section>

    </>
  );
};

export default DataScience;
